export default (errors, property) => errors?.some((err) => err.propertyName === property);
